import {
  addDoc,
  arrayRemove,
  arrayUnion,
  collection,
  doc,
  getDoc,
  setDoc,
  updateDoc,
} from "firebase/firestore"
import { httpsCallable } from "firebase/functions"
import { PopupService } from "react-ui-components/components/PopupService"
import { LoadingService } from "react-ui-components/components/LoadingService"
import { GenericListServiceConfig } from "./types"
import { db, functions } from "../firebase"

export const deleteCollectionAndImages = httpsCallable(functions, "deleteCollectionAndImages")

export const deleteAllContent = async (
  documentIds: string | string[],
  mainId: string | undefined,
  Service: GenericListServiceConfig,
) => {
  try {
    LoadingService.setLoading(true)

    const ids = Array.isArray(documentIds) ? documentIds.join(",") : documentIds
    const collectionInfo = Service.getListLocation(mainId)
    const collectionPath = Array.isArray(collectionInfo)
      ? collectionInfo.join("/")
      : collectionInfo.path
    await deleteCollectionAndImages({
      bucketPath: Service.IMAGES_BUCKET,
      collectionPath,
      documentIds: ids,
    })
    console.log("Collection and images deleted successfully.")
  } catch (error: any) {
    const msg = "Error deleting collection and images"
    LoadingService.setLoading(true, msg, true)
    console.error(msg, error)
    PopupService.pushPopup(`${msg}\n${error?.message || error}`)
  } finally {
    LoadingService.setLoading(false)
  }
}

export async function addSubcollection(
  docPath: string,
  subcollectionPropertyName: string,
  subcollectionName: any,
  subcollectionDocId: string,
  data: any,
) {
  try {
    const docRef = doc(db, docPath)

    await addDocumentToSubcollection(docPath, subcollectionName, subcollectionDocId, data)

    await updateDoc(docRef, {
      [subcollectionPropertyName]: arrayUnion(subcollectionName),
    })
  } catch (error: any) {
    console.error("Error adding subcollection:", error)
    throw new Error(`Failed to add subcollection: ${error?.message || error}`)
  }
}

export async function removeSubcollectionProperty(
  docPath: string,
  subcollectionPropertyName: string,
  subcollectionName: unknown,
) {
  const docRef = doc(db, docPath)

  await updateDoc(docRef, {
    [subcollectionPropertyName]: arrayRemove(subcollectionName),
  })
}

export async function addDocumentToSubcollection(
  docPath: string,
  subcollectionName: string,
  subcollectionDocId: string | undefined,
  data: any,
) {
  try {
    const subcollectionRef = collection(doc(db, docPath), subcollectionName)
    await setDoc(doc(subcollectionRef, subcollectionDocId), data)
  } catch (error: any) {
    console.error("Error adding document to subcollection:", error)
    throw new Error(`Failed to add document to subcollection: ${error?.message || error}`)
  }
}

export async function getSubcollectionData(
  docPath: string,
  subcollectionName: string,
  subcollectionDocId: string | undefined,
) {
  try {
    const subcollectionRef = collection(doc(db, docPath), subcollectionName)
    const docRef = await getDoc(doc(subcollectionRef, subcollectionDocId))
    return docRef.data()
  } catch (error: any) {
    console.error("Error getting subcollection data:", error)
    throw new Error(`Failed to get subcollection data: ${error?.message || error}`)
  }
}
